module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Quote1-b462fd2af1289d8ceccf65cf2bea7e94.svg";